export const categories = [
  {
    slug: 'ru-men-jiao-cheng',
    name: '入门教程',
    description: '为零基础学习者精心准备的六角琴入门指南，从选购到基本演奏技巧，助您轻松迈出第一步。',
    icon: 'ri-book-open-line',
  },
  {
    slug: 'yan-zou-ji-qiao',
    name: '演奏技巧',
    description: '深入探索六角琴的进阶演奏方法，包括指法训练、音色控制与曲目演绎技巧。',
    icon: 'ri-music-line',
  },
  {
    slug: 'xuan-gou-zhi-nan',
    name: '选购指南',
    description: '全面对比不同价位与品牌的六角琴，帮助您根据预算与需求选择最适合的乐器。',
    icon: 'ri-shopping-bag-3-line',
  },
  {
    slug: 'pin-pai-dui-bi',
    name: '品牌对比',
    description: '深度评测国内外主流六角琴品牌，从工艺、音色到售后，为您做出明智选择。',
    icon: 'ri-medal-line',
  },
  {
    slug: 'li-shi-qi-yuan',
    name: '历史起源',
    description: '追溯六角琴数百年的发展历程，了解这一独特乐器的文化传承与演变故事。',
    icon: 'ri-history-line',
  },
  {
    slug: 'wei-hu-bao-yang',
    name: '维护保养',
    description: '学习六角琴的日常保养技巧，延长乐器寿命，保持最佳演奏状态。',
    icon: 'ri-tools-line',
  },
];